import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  useTheme,
  useMediaQuery,
  Checkbox,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./Requirement.module.css";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const job = [
  { value: "Full_Time", label: "Full Time" },
  { value: "Contract", label: "Contract" },
  { value: "W2", label: "W2" },
  { value: "1099", label: "1099" },
  { value: "Contract_To_Hire", label: "Contract To Hire" },
];

const locations = [
  { value: "california", label: "California" },
  { value: "taxes", label: "Texas" },
];

const work = [
  { value: "GC", label: "GC" },
  { value: "USC", label: "USC" },
];

const preference = [
  { value: "Onsite", label: "Onsite" },
  { value: "Hybrid", label: "Hybrid" },
  { value: "Remote", label: "Remote" },
];

const mode = [
  { value: "Phone", label: "Phone" },
  { value: "Virtual", label: "Virtual" },
  { value: "Inperson", label: "In Person" },
];

const post = [
  { value: "benchsales", label: "Bench Sales" },
  { value: "benchsales&candidate", label: "Bench Sales & Candidate " },
];

const limit = [
  { value: "min", label: "Minimum " },
  { value: "max", label: "Maximum " },
];

const respond = [
  { value: "1hour", label: "1 Hour" },
  { value: "5hour", label: "5 Hour" },
  { value: "1day", label: "1 Day" },
  { value: "5days", label: "5 Days" },
  { value: "7days", label: "7 Days" },
];

const report = [
  { value: "throughemail", label: "Through Email" },
  { value: "povitalaccount", label: "Povital Account" },
];

const authirization = [
  {
    value: "GC",
    label: "GC",
  },
];
const customStyle = {
  width: "100%",
  padding: "3px",
  "& .MuiInputLabel-root": { fontSize: "14px" },
};

const PostJobRequirement = () => {
  const [selectedFileName, setSelectedFileName] = useState("");
  const [text, setText] = useState("");
  const textareaRef = useRef(null);
  const navigate = useNavigate();

  const location = useLocation();
  const { candidate } = location.state || {};

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileName(file.name);
    }
  };

  return (
    // <RootComponents>
      <>
      <Box className={styles.post_required_view_structure}></Box>

      <Box className={styles.apply_text}>
        <Typography>Hi Ashit Kumar</Typography>
        <Typography>You are responding to Mohan Mishra’s job post.</Typography>
      </Box>
      <Box className={styles.ask_text}>
        <Grid container>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Candidate Name"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField variant="standard" label="Gender" sx={{ width: "100%" }}>
              {post.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Job Profile"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Experience"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Phone No"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="E-Mail ID"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Work Authorization"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Location"
              sx={{ width: "100%" }}
            >
              {respond.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Willing to Relocate"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              variant="standard"
              label="Rate Expectaion"
              sx={{ width: "100%" }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: "10px" }}>
            <Box className={styles.mandatory_description}>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
                placeholder="Message to Mohan Mishra"
                ref={textareaRef}
                value={text}
                onChange={handleChange}
                style={{
                  overflow: "hidden",
                  resize: "none",
                  border: "1px solid #6b7280",
                  width: "100%",
                }}
              ></textarea>
            </Box>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              padding: "10px",
            }}
          >
            <Box sx={{ padding: "10px 0" }}>
              <Typography
                className={styles.profile_box_list}
                sx={{ padding: "10px", width: "12rem" }}
              >
                <div>
                  <Typography
                    onClick={handleButtonClick}
                    style={{ cursor: "pointer" }}
                  >
                    <b style={{ fontSize: "14px" }}>Add Resume</b>
                  </Typography>
                  <input
                    id="fileInput"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  {selectedFileName && (
                    <p
                      style={{
                        marginTop: "6px",
                        fontSize: "14px",
                        color: "#1b89de",
                      }}
                    >
                      Selected file: {selectedFileName}
                    </p>
                  )}
                </div>
              </Typography>
            </Box>
            <Box sx={{ padding: "10px" }}>
              <Typography
                className={styles.profile_box_list}
                sx={{ padding: "10px", width: "12rem" }}
              >
                <div>
                  <Typography
                    onClick={handleButtonClick}
                    style={{ cursor: "pointer" }}
                  >
                    <b>Visa & DL (option)</b>
                  </Typography>
                  <input
                    id="fileInput"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  {selectedFileName && (
                    <p
                      style={{
                        marginTop: "6px",
                        fontSize: "14px",
                        color: "#1b89de",
                      }}
                    >
                      Selected file: {selectedFileName}
                    </p>
                  )}
                </div>
              </Typography>
            </Box>
            <Box>
              <Typography
                className={styles.profile_check_list}
                sx={{ margin: "10px" }}
              >
                Need Talk to Candidate
                <Checkbox {...label} />
              </Typography>
            </Box>
            <Box>
              <Typography
                className={styles.profile_check_list}
                sx={{ margin: "10px" }}
              >
                RTR Before Submission
                <Checkbox {...label} />
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Box>

      <Box className={styles.post_btn} onClick={() => navigate("/apply-now")}>
        <button>Apply Now</button>
      </Box>
      </>
    // </RootComponents>
  );
};

export default PostJobRequirement;
